export default class QueryStringHelper {
    static objectToQuery(object) {
      return Object.keys(object).reduce((acc, key) => {
        if (object[key] === undefined) { return acc; }
        if (acc === '') { return `?${key}=${object[key]}`; }
        return `${acc}&${key}=${object[key]}`;
      }, '');
    }
  
    // Ref: https://gomakethings.com/how-to-get-the-value-of-a-querystring-with-native-javascript/
    static getValueByKey(field, url = window.location.href) {
      const regExp = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
      const match = regExp.exec(url);
  
      return match ? match[1] : undefined;
    }
  }
  


// WEBPACK FOOTER //
// ./src/utils/QueryStringUtil.js